import { useEffect, useLayoutEffect, useRef } from "react";
import { isDev, validateTidalLicense } from "../../../base/index.js";
function useWarnToMemoize(valueToMonitor, options = {}) {
  const { limit = 1, name, message = "" } = options;
  const rCount = useRef(0);
  const rParams = useRef({ limit, name, warned: false, prevValue: JSON.stringify(valueToMonitor), message });
  useLayoutEffect(() => void (rParams.current = { ...rParams.current, limit, name, message }), [limit, name, message]);
  useEffect(() => {
    if (isDev()) {
      const { limit: limit2, name: name2, warned, prevValue, message: message2 } = rParams.current;
      if (warned) return;
      const nextValue = JSON.stringify(valueToMonitor);
      if (nextValue !== prevValue) {
        rCount.current = 0;
      } else {
        rCount.current++;
      }
      if (rCount.current > limit2) {
        if (name2) {
          console.warn(`[useWarnToMemoize]: "${name2}" has been rendered more than ${limit2} times. ${message2}`);
        } else {
          console.warn(`[useWarnToMemoize]: has been rendered more than ${limit2} times. ${message2}`);
        }
        rParams.current.warned = true;
      }
      rParams.current.prevValue = nextValue;
    }
  }, [valueToMonitor]);
}
validateTidalLicense();
export {
  useWarnToMemoize
};
//# sourceMappingURL=useWarnToMemoize.js.map
